<template>
<v-main>
  <v-layout row wrap>
    <v-flex xs12 sm6>
      <v-card class="mx-2 rounded-xl px-2 pb-4">
        <v-card-title>
          <v-toolbar-title>
            {{ descricaoFuncionario }} ativos
          </v-toolbar-title>
          <v-spacer />
          <v-text-field v-model="searchAtivos" append-icon="search" label="Buscar" single-line hide-details />
        </v-card-title>
        <!-- <v-simple-table fixed-header height="460px" >
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left" v-for="(item, index) in headersDesativo" :key="index">
                  {{item.text}}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in lista" :key="index">
                <td>{{ item.nome }}</td>
                <td>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn text small v-on="on" @click="alterarDadosFuncionario(item)">
                        <v-icon color="success">
                          edit
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Alterar dados deste item</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn text small v-on="on" @click="desativarFuncionario(item)">
                        <v-icon medium color="success">
                          remove
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>desativar este item</span>
                  </v-tooltip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table> -->
        <!-- {{listaFuncionariosAtivos}} -->
        <v-data-table :headers="headers" no-data-text="Nenhum item disponível" :items="listaFuncionariosAtivos" :search="searchAtivos">
          <template v-slot:item.actions="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn text small v-on="on" @click="alterarDadosFuncionario(item)">
                  <v-icon color="success">
                    edit
                  </v-icon>
                </v-btn>
              </template>
              <span>Alterar dados deste item</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn text small v-on="on" @click="desativarFuncionario(item)">
                  <v-icon medium color="success">
                    mdi-delete
                  </v-icon>
                </v-btn>
              </template>
              <span>desativar este item</span>
            </v-tooltip>
          </template>
          <template v-slot:no-data>
            <v-alert dark :value="true" class="rounded-xl" color="error" icon="warning">
              Your search for "{{ searchDesativos }}" found no results.
            </v-alert>
          </template>
        </v-data-table>
        <!-- <v-data-table :headers="headers" no-data-text="Nenhum item disponível" :items="listaFuncionariosAtivos" :search="searchAtivos">

          <template v-slot:items="props">
            <td class="subheading">
              {{ props.item.nome }}
            </td>

            <td class="justify-center layout px-0">

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn fab small v-on="on" @click="alterarDadosFuncionario(props.item)">
                    <v-icon color="success">
                      edit
                    </v-icon>
                  </v-btn>
                </template>
                <span>Alterar dados deste item</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn fab small v-on="on" @click="desativarFuncionario(props.item)">
                    <v-icon medium color="success">
                      remove
                    </v-icon>
                  </v-btn>
                </template>
                <span>desativar este item</span>
              </v-tooltip>
            </td>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              sua busca por "{{ searchAtivos }}" não encontrou resultados.
            </v-alert>
          </template>
        </v-data-table> -->
      </v-card>
    </v-flex>

    <v-flex xs12 sm6>
      <v-card class="mr-2 rounded-xl pb-4">
        <v-card-title>
          <v-toolbar-title>
            {{ descricaoFuncionario }} inativos
          </v-toolbar-title>
          <v-spacer />
          <v-text-field v-model="searchDesativos" append-icon="search" label="Buscar" single-line hide-details />
        </v-card-title>
        <!-- <v-simple-table fixed-header height="460px" >
          <template v-slot:default>
            <thead>
              <tr>
                <th v-for="(item, index) in headers" :key="index">
                  {{item.text}}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in listaInativos" :key="index">
                <td>{{ item.nome }}</td>

            <td >
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn icon color="primary" v-on="on" @click="ativarFuncionario(item)">
                    <v-icon medium>
                      add
                    </v-icon>
                  </v-btn>
                </template>
                <span>Ativar este item</span>
              </v-tooltip>
            </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table> -->
        <v-data-table no-data-text="Nenhum item disponível" :headers="headersDesativo" :items="listaFuncionariosDesativos" :search="searchDesativos">
          <template v-slot:item.actions="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon color="#4DB6AC" v-on="on" @click="ativarFuncionario(item)">
                  <v-icon medium>
                    add
                  </v-icon>
                </v-btn>
              </template>
              <span>Ativar este item</span>
            </v-tooltip>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              Your search for "{{ searchDesativos }}" found no results.
            </v-alert>
          </template>
        </v-data-table>
        <!-- <v-data-table no-data-text="Nenhum item disponível" :headers="headersDesativo" :items="listaFuncionariosDesativos" :search="searchDesativos">
          <template v-slot:items="props">
            <td class="subheading">
              {{ props.item.nome }}
            </td>

            <td class="justify-center layout px-0">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn fab color="#4DB6AC" small v-on="on" @click="ativarFuncionario(props.item)">
                    <v-icon medium>
                      add
                    </v-icon>
                  </v-btn>
                </template>
                <span>Ativar este item</span>
              </v-tooltip>
            </td>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              Your search for "{{ searchDesativos }}" found no results.
            </v-alert>
          </template>
        </v-data-table> -->
      </v-card>
    </v-flex>
  </v-layout>
</v-main>
</template>

<script>
// import Cookies from 'js-cookie'

export default {
  props: {
    listaFuncionariosAtivos: Array,
    listaFuncionariosDesativos: Array,
    descricaoFuncionario: String,
    tipoFuncionario: String
  },
  data () {
    return {
      page: 1,
      searchAtivos: '',
      searchDesativos: '',
      lista: [],
      listaInativos: [],
      isEditing: true,
      user: null,
      headers: [{
        text: 'Nome',
        align: 'center',
        sortable: true,
        value: 'nome'
      },
      {
        text: 'Ações',
        value: 'actions',
        align: 'center',
        sortable: false
      }
      ],
      headersDesativo: [{
        text: 'Nome',
        align: 'center',
        sortable: true,
        value: 'nome'
      },
      {
        text: 'Ações',
        value: 'actions',
        align: 'center',
        sortable: false
      }
      ]
    }
  },
  watch: {
    searchDesativos (val) {
      if (val != '') {
        let lista = []
        this.listaFuncionariosDesativos.forEach(s => {
          if (
            s.nome.includes(val)) {
            lista.push(s)
          }
        })
        this.listaInativos = lista
      } else {
        console.log('---')
        this.listaInativos = this.listaFuncionariosDesativos
      }
    },
    searchAtivos (val) {
      if (val != '') {
        let lista = []
        this.listaFuncionariosAtivos.forEach(s => {
          if (
            s.nome.includes(val)) {
            lista.push(s)
          }
        })
        this.lista = lista
      } else {
        console.log('---')
        this.lista = this.listaFuncionariosAtivos
      }
    }
  },
  mounted () {
    console.log('em mounted adm...')
    this.user = this.$store.getters.usuario
    this.lista = this.listaFuncionariosAtivos
    this.listaInativos = this.listaFuncionariosDesativos
    // console.log(this.user);
  },
  created () {
    console.log('created...')
  },
  methods: {

    alterarDadosFuncionario (item) {
      console.log(item)
      this.$emit('alterar-dados-funcionario', item, this.tipoFuncionario)
    },
    desativarFuncionario (item) {
      console.log(item)
      this.$emit('desativar-funcionario', item, this.tipoFuncionario)
    },
    ativarFuncionario (item) {
      console.log(item)
      this.$emit('ativar-funcionario', item, this.tipoFuncionario)
    }

  }
}
</script>

<style scoped>
.md-card {
  width: 320px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}

.feedback {
  background-color: #31B0D5;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  border-color: #46b8da;
}

#mybutton {
  position: fixed;
  bottom: 20px;
  right: 10px;
}
</style>
